/**
 * Mapping of Tripetto block types to Formly field types
 * This configuration defines how each Tripetto block type should be converted to a Formly field type
 */
export const BLOCK_TYPE_MAPPING: Record<string, string> = {
	'tripetto-block-text': 'mat-formly-input',
	'tripetto-block-textarea': 'mat-formly-textarea',
	'tripetto-block-number': 'mat-formly-input',
	'tripetto-block-email': 'mat-formly-input',
	'tripetto-block-password': 'mat-formly-input',
	'tripetto-block-url': 'mat-formly-input',
	'tripetto-block-phone-number': 'mat-formly-input',
	'tripetto-block-date': 'mat-formly-date',
	'tripetto-block-datetime': 'mat-formly-date',
	'tripetto-block-dropdown': 'mat-formly-select',
	'tripetto-block-dropdown2': 'mat-formly-select',
	'tripetto-block-radiobuttons': 'mat-formly-radio',
	'tripetto-block-radiobuttons2': 'mat-formly-radio',
	'tripetto-block-radiobuttons3': 'mat-formly-radio',
	'tripetto-block-checkbox': 'mat-formly-check',
	'tripetto-block-checkboxes': 'mat-formly-check',
	'tripetto-block-checkboxes2': 'mat-formly-check',
	'tripetto-block-yes-no': 'mat-formly-radio',
	'tripetto-block-hidden-field': 'mat-formly-hidden',
	'tripetto-block-address': 'mat-formly-address',
	'tripetto-block-file-upload': 'mat-formly-file-upload',
	'ahs-block-chips': 'mat-formly-chips',
	'tripetto-block-statement': 'mat-formly-static',
	languages: 'mat-formly-static',
	'tripetto-block-setter': 'mat-formly-hidden',
	'ahs-block-setter': 'mat-formly-hidden',
	'ahs-component': 'mat-formly-hidden' // Custom components need manual handling
};
